import React from "react";
import {
  Avatar,
  Chip,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Paper,
} from "@mui/material";
import { formatFileURL } from "../../../utils/helper/appHelpers";
import { DELIVERY_STATUS } from "../../../utils/Constant";
// import { formatFileURL } from "@/utils/helpers/appHelpers";

export default function OrderRequestSent({ orderReqInfo = {} }) {
  if (!orderReqInfo?.requestSent?.length) {
    return <Typography sx={{textAlign:'center' ,my: 2}} variant="subtitle1">No request sent yet</Typography>;
  }

  return (
    <TableContainer component={Paper} sx={{ borderRadius: 1, boxShadow: 3, my: 2 }}>
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell>Rider</TableCell>
            <TableCell align="center">Distance (km)</TableCell>
            <TableCell align="center">Radius (km)</TableCell>
            <TableCell align="center">Status</TableCell>
            <TableCell>Remark</TableCell>
          </TableRow>
        </TableHead>

        <TableBody>
          {orderReqInfo.requestSent
          .filter(req => req.status !== DELIVERY_STATUS.EXPIRED)
          .map((req, index) => (
            <TableRow key={req._id || index} hover>
              {/* Rider Info */}
              <TableCell>
                <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                  <Avatar
                    src={
                      formatFileURL(req?.riderJson?.profilePic) ||
                      "/rider-placeholder.png"
                    }
                    alt="Rider"
                    sx={{ width: 32, height: 32 }}
                  />
                  <Typography variant="body2">
                    {req.riderJson?.userName || "Unknown Rider"}
                  </Typography>
                </div>
              </TableCell>

              {/* Distance */}
              <TableCell align="center">
                {req.distanceInKm?.toFixed(2)}
              </TableCell>

              {/* Radius */}
              <TableCell align="center">{orderReqInfo.currentRadius}</TableCell>

              {/* Status */}
              <TableCell align="center">
                <Chip
                  size="small"
                  label={req.status}
                  color={
                    req.status === "PENDING"
                      ? "warning"
                      : req.status === "ACCEPTED"
                      ? "success"
                      : "error"
                  }
                  variant="outlined"
                />
              </TableCell>

              {/* Remark */}
              <TableCell>
                <Typography
                  variant="body2"
                  color="text.secondary"
                  noWrap
                  sx={{ maxWidth: 180 }}
                >
                  {req.deliveryInfo?.remark || "--"}
                </Typography>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
